<!--Questa condizione si verifica subito dopo l'autenticazione-->
<app-loading-screen *ngIf="!securityDataService.isAuthenticated()"></app-loading-screen>
<app-canvas-layout *ngIf="securityDataService.isAuthenticated()">
    <div slot="header">
        <app-private-area-header></app-private-area-header>
    </div>
    <!--
    MAIN SIDE NAV
    -->
    <div slot="side1" style="min-width: 280px; height: 100%;">
        <!--
        LOGO + MENU LATERALE AD ALBERO
        -->
        <ng-container *ngIf="appearance.privateArea.menu && appearance.privateArea.menu.show">
            <!-- <app-flipping-logo *ngIf="appearance.privateArea.header.logo.front.show"
                            [height]="appearance.privateArea.header.logo.front.height+'px'"
                            [frontImage]="appearance.privateArea.header.logo.front.src"
                            [frontImageHeight]="appearance.privateArea.header.logo.front.height+'px'"
                            [backImage]="appearance.privateArea.header.logo.back.show ? appearance.privateArea.header.logo.back.src : null"
                            [backImageHeight]="appearance.privateArea.header.logo.back.show ? appearance.privateArea.header.logo.back.height+'px' : null">
            </app-flipping-logo> -->
            <!--
            MENU LATERALE AD ALBERO
            -->
            <app-tree-menu #menuTree></app-tree-menu>
        </ng-container>
        <!--
        HORIZONTAL MENU IN MODALITA' MOBILE
        -->
        <app-horizontal-menu *ngIf="appearance.privateArea.header.menu && appearance.privateArea.header.menu.show"
                             context="private"
                             [mobile]="true"
                             [settings]="{mode: appearance.publicArea.header.menu.mode,
                                spacing: appearance.publicArea.header.menu.spacing,
                                menuItemStyle: {
                                    fontSize: appearance.publicArea.header.menu.fontSize,
                                    fontColor: appearance.publicArea.header.menu.fontColor,
                                    bgColor: appearance.publicArea.header.menu.bgColor,
                                    borderColor: appearance.publicArea.header.menu.borderColor,
                                    underlineColor: appearance.publicArea.header.menu.underlineColor
                                },
                                hoverMenuItemStyle: {
                                    fontColor: appearance.publicArea.header.menu.hoverItemFontColor,
                                    bgColor: appearance.publicArea.header.menu.hoverItemBgColor,
                                    borderColor: appearance.publicArea.header.menu.hoverItemBorderColor,
                                    underlineColor: appearance.publicArea.header.menu.hoverItemUnderlineColor
                                },
                                selectedMenuItemStyle: {
                                    fontColor: appearance.publicArea.header.menu.selectedItemFontColor,
                                    bgColor: appearance.publicArea.header.menu.selectedItemBgColor,
                                    borderColor: appearance.publicArea.header.menu.selectedItemBorderColor,
                                    underlineColor: appearance.publicArea.header.menu.selectedItemUnderlineColor
                                }}">
        </app-horizontal-menu>
    </div>
    <!--
    PAGE BODY
    -->
    <div slot="page" style="height: 100%;">
        <app-disabled-user-page *ngIf="!securityDataService.userProfile.enabled"></app-disabled-user-page>
        <app-no-permissions-page *ngIf="securityDataService.userProfile.enabled && !securityDataService.userProfile.authorities.includes(securityDataService.requiredAuthorities)"></app-no-permissions-page>
        <ng-content *ngIf="securityDataService.userProfile.enabled && securityDataService.userProfile.authorities.includes(securityDataService.requiredAuthorities)"></ng-content>
    </div>
    <!--
    ACCESSORY SIDE NAV
    -->
    <div slot="side2">SIDENAV2</div>
</app-canvas-layout>
